import React, { useEffect, useState } from 'react';
import { Button } from '../../ui/button';
import { PRESETS } from './range';

const sel = 'h-9 rounded-[7px] border border-[#dedbd1] bg-[#fffefa] px-2.5 text-sm text-[#20211d] focus:outline-none focus:ring-2 focus:ring-[#F56F05]/30';
const lab = 'flex flex-col gap-1 text-[10px] font-bold tracking-[0.08em] uppercase text-[#74776a]';

export const AnalyticsControls = ({ value, onPreset, onApply, onGroup, onCompare }) => {
  const [from, setFrom] = useState(value.start);
  const [to, setTo] = useState(value.end);
  const [err, setErr] = useState('');
  useEffect(() => { setFrom(value.start); setTo(value.end); }, [value.start, value.end]);

  const apply = (e) => {
    e.preventDefault();
    if (!from || !to || from > to) { setErr('Choose a From date on or before the Through date.'); return; }
    setErr('');
    onApply(from, to);
  };

  return (
    <form onSubmit={apply} noValidate className="flex flex-wrap items-end gap-3 rounded-[9px] border border-[#e7e4db] bg-[#faf9f6] p-3 sm:p-4" data-testid="analytics-controls">
      <label className={lab}>Period
        <select className={sel} value={value.preset} onChange={e => onPreset(e.target.value)} data-testid="analytics-preset">
          {PRESETS.map(p => <option key={p.value} value={p.value}>{p.label}</option>)}
        </select>
      </label>
      <label className={lab}>From
        <input type="date" className={sel} value={from} max={to} onChange={e => setFrom(e.target.value)} data-testid="analytics-from" required />
      </label>
      <label className={lab}>Through
        <input type="date" className={sel} value={to} min={from} onChange={e => setTo(e.target.value)} data-testid="analytics-to" required />
      </label>
      <Button type="submit" variant="outline" className="h-9" data-testid="analytics-apply">Apply</Button>
      <label className={lab}>Chart view
        <select className={sel} value={value.group} onChange={e => onGroup(e.target.value)} data-testid="analytics-group">
          <option value="day">Daily</option>
          <option value="week">Weekly</option>
          <option value="month">Monthly</option>
        </select>
      </label>
      <label className="flex items-center gap-2 h-9 text-sm text-[#20211d] cursor-pointer select-none">
        <input type="checkbox" className="h-4 w-4 accent-[#F56F05]" checked={value.compare} onChange={e => onCompare(e.target.checked)} data-testid="analytics-compare" />
        Compare with previous period
      </label>
      {err && <p className="w-full text-xs text-red-600" data-testid="analytics-range-error">{err}</p>}
    </form>
  );
};
